export default {
    displayName: 'CRL8 Gallery View',
    allowableParents: ['Section'],
};